import { useEffect, useState } from 'react'
import { MdEvent } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { RxCross1 } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import baseURL from '../../config/api';
import Pagination from '../../components/Pagination';
import { formatUSPhone } from '../../utils/phoneFormatter';
import useGroup from '../../hook/useGroup';
import useSubGroup from '../../hook/useSubGroup';
import { SubGroupSelect } from '../../components/SubGroupSelect';
import { formatDateTimeForDisplay } from '../../utils/getUserDateFormat';
import Cookies from 'js-cookie';

const heading = ["Actions", "Event Name", "Start Date", "End Date", "Event Coordinator Name", "Event Coordinator Email", "Event Coordinator Phone", "Guest", "Active"];

const Event = () => {
  const token = Cookies.get("token-my-cdir");
  const navigate = useNavigate();
  const { selectedGroupId, isSuperAdmin }: any = useGroup();
  const { selectedSubGroupId }: any = useSubGroup();
  const location = useLocation();
  const pathRoot = isSuperAdmin ? "superadmin" : "admin";
  const [showEntries, setShowEntries] = useState<number>(10);
  const [searchTableData, setSearchTableData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);
  const [eventFilterValue, setEventFilterValue] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
    page: 0,
    size: 10,
  });
  const [totalLength, setTotalLength] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = useState<string>("Event Name");
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);

  useEffect(() => {
    if (!isFirstTime) {
      setSelectedFilter("Event Name");
      setEventFilterValue(0);
      if (searchValue !== "") {
        setSearchValue("");
        setIsFirstTime(false);
      }
      else {
        setPaginationModel({
          page: 0,
          size: 10
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupId])

  useEffect(() => {
    if (!isFirstTime) {
      setPaginationModel({
        page: 0,
        size: 10
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSubGroupId])

  useEffect(() => {
    if (searchValue === "" && !isFirstTime) {
      const newPaginationModel = {
        page: 0,
        size: paginationModel.size,
      };

      setPaginationModel(newPaginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue === "") {
      setIsFirstTime(false)
      apiCall(paginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const apiCall = (newPaginationModel: { page: number, size: number }) => {
    if (selectedGroupId > 0) {

      if (selectedSubGroupId > 0) {
        setIsDataLoaded(true);
        fetch(`${baseURL}event/GetEventReportByGroupIdAndSubGroupIdPaging/${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
          headers: {
            Authorization: `Bearer ${token?.toString()}`
          }
        })
          .then((res) => res.json())
          .then((data) => {
            const result = data.eventReport.map((item: any) => {
              return {
                ...item,
                startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                isActive: item.isActive ? "Yes" : "No"
              };
            })

            setSearchTableData(result);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          }).catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
      }
      else {
        setIsDataLoaded(true);
        fetch(`${baseURL}event/GetEventReportByGroupIdPaging/${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
          headers: {
            Authorization: `Bearer ${token?.toString()}`
          }
        })
          .then((res) => res.json())
          .then((data) => {
            const result = data.eventReport.map((item: any) => {
              return {
                ...item,
                startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                isActive: item.isActive ? "Yes" : "No"
              };
            })

            setSearchTableData(result);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          }).catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
      }
    }
    else {
      setIsDataLoaded(false);
      setSearchTableData([]);
      setTotalLength(0);
    }
  }

  useEffect(() => {
    if (location.state?.refresh) {
      apiCall(paginationModel);
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;

    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        const newPaginationModel = {
          page: 0,
          size: paginationModel.size,
        };

        setPaginationModel(newPaginationModel);

      }, 1000);
    }

    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue !== "" && !isFirstTime) {
      filteApiCall(paginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
    let filterData: any[] = [];
    setIsDataLoaded(true);
    if (selectedGroupId > 0) {
      if (selectedSubGroupId > 0) {
        switch (eventFilterValue) {
          case 0:
            fetch(
              `${baseURL}event/GetEventReportByGroupIdAndSubGroupIdAndSearchWithEventName/${searchValue},${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
              headers: {
                Authorization: `Bearer ${token?.toString()}`
              }
            }
            )
              .then((res) => res.json())
              .then((data) => {
                filterData = data.eventReport.map((item: any) => {
                  return {
                    ...item,
                    startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                    endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                    isActive: item.isActive ? "Yes" : "No"
                  };
                })

                setSearchTableData(filterData);
                setTotalLength(data.count);
                setIsDataLoaded(false);

              })
              .catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
              });

            break;
          case 1:
            fetch(
              `${baseURL}event/GetEventReportByGroupIdAndSubGroupIdAndSearchWithEventCoordinatorNameEmailAddress/${searchValue},${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
              headers: {
                Authorization: `Bearer ${token?.toString()}`
              }
            }
            )
              .then((res) => res.json())
              .then((data) => {
                filterData = data.eventReport.map((item: any) => {
                  return {
                    ...item,
                    startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                    endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                    isActive: item.isActive ? "Yes" : "No"
                  };
                })
                setSearchTableData(filterData);
                setTotalLength(data.count);
                setIsDataLoaded(false);

              })
              .catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
              });

            break;

        }
      }
      else {
        switch (eventFilterValue) {
          case 0:
            fetch(
              `${baseURL}event/GetEventReportByGroupIdAndSearchWithEventName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
              {
                headers: {
                  Authorization: `Bearer ${token?.toString()}`
                }
              }
            )
              .then((res) => res.json())
              .then((data) => {
                filterData = data.eventReport.map((item: any) => {
                  return {
                    ...item,
                    startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                    endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                    isActive: item.isActive ? "Yes" : "No"
                  };
                })

                setSearchTableData(filterData);
                setTotalLength(data.count);
                setIsDataLoaded(false);

              })
              .catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
              });

            break;
          case 1:
            fetch(
              `${baseURL}event/GetEventReportByGroupIdAndSearchWithEventCoordinatorNameEmailAddress/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
              {
                headers: {
                  Authorization: `Bearer ${token?.toString()}`
                }
              }
            )
              .then((res) => res.json())
              .then((data) => {
                filterData = data.eventReport.map((item: any) => {
                  return {
                    ...item,
                    startDate: item.startDate ? format(new Date(item.startDate), "MM/dd/yyyy hh:mm a") : "No date",
                    endDate: item.endDate ? format(new Date(item.endDate), "MM/dd/yyyy hh:mm a") : "No date",
                    isActive: item.isActive ? "Yes" : "No"
                  };
                })
                setSearchTableData(filterData);
                setTotalLength(data.count);
                setIsDataLoaded(false);

              })
              .catch((error) => {
                console.log(error);
                setIsDataLoaded(false);
                setSearchTableData([]);
                setTotalLength(0);
              });

            break;

        }
      }
    }
    else {
      setIsDataLoaded(false);
      setSearchTableData([]);
      setTotalLength(0);
    }
  }

  const applyFilter = () => {
    setSelectedFilter(() =>
      eventFilterValue === 0 ? "Event Name" : "Coordinator Name"
    );
    setSearchValue("");
    setDisplayFilter(false);
  };

  const clearFilter = () => {
    setSearchValue("");
    setDisplayFilter(false);
  };

  const addEvent = () => {
    navigate(`/${pathRoot}/event/addEvent`);
  }

  const editEvent = (id: string) => {
    navigate(`/${pathRoot}/event/editEvent/${id}`);
  }

  const deleteEvent = (id: string) => {
    navigate(`/${pathRoot}/event/deleteEvent/${id}`);
  }

  return (
    <section className="event__container p-3 md:p-4 overflow-x-hidden">
      <div className="min-w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
        <h1 className="px-2 md:px-4 py-1.5 flex items-center gap-2">
          <MdEvent fontSize={20} />
          <span className="text-base md:text-lg">Events</span>
        </h1>

        <div className="flex flex-col md:flex-row gap-2 md:gap-4 w-full md:w-auto">
          <button
            className="bg-secondary hover:bg-custom-blue px-4 py-2 md:py-1.5 rounded-sm text-white w-full md:w-auto"
            onClick={addEvent}
          >
            Add Event
          </button>

          <SubGroupSelect />
        </div>
      </div>

      {/* FILTER + SEARCH */}
      <div className="flex flex-col md:flex-row gap-3 justify-between md:items-center border border-black p-2 mt-4">
        <div className="relative flex flex-col md:flex-row gap-3 items-start md:items-center w-full">

          <div className="relative w-full md:w-auto">
            <button
              className="bg-secondary text-white px-3 py-2 md:py-1 rounded-md flex items-center justify-between w-full md:w-auto whitespace-nowrap"
              onClick={() => setDisplayFilter(!displayFilter)}
            >
              {selectedFilter}
              <RiArrowDownSFill className="ml-1" />
            </button>

            <div
              className={`${displayFilter ? "block" : "hidden"
                } absolute z-10 w-full md:w-40 p-2 bg-white border border-black mt-2 md:mt-0 md:top-0 md:left-full`}
            >
              <div className="flex justify-between">
                <label className="text-xs font-bold">Fields</label>
                <div
                  onClick={() => setDisplayFilter(false)}
                  className="w-4 h-4 cursor-pointer text-sm text-center"
                >
                  <RxCross1 />
                </div>
              </div>

              <select
                className="w-full text-xs py-1 border mt-1"
                value={eventFilterValue}
                onChange={(e) =>
                  setEventFilterValue(parseInt(e.target.value))
                }
              >
                <option value="0">Event Name</option>
                <option value="1">Coordinator Name</option>
              </select>

              <div className="flex mt-2 justify-between">
                <button
                  className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                  onClick={() => applyFilter()}
                >
                  Apply Filter
                </button>

                <button
                  className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                  onClick={() => clearFilter()}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          {/* SEARCH */}
          <div className="flex items-center gap-2 w-full border px-2 py-1 rounded md:border-none">
            <div className="h-4 w-4 text-gray-900">
              <BsSearch />
            </div>

            <input
              type="text"
              placeholder="Search…"
              className="w-full text-sm md:text-lg pl-2 outline-none"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="my-2" />

      {!isDataLoaded ? (
        <>
          {/* TABLE WRAPPER */}
          <div className="w-full overflow-x-auto">
            <table className="min-w-[800px] w-full bg-white">
              <thead className="bg-gray-200 whitespace-nowrap">
                <tr>
                  {heading.map((item, index) => (
                    <th
                      key={index}
                      className="px-4 md:px-6 py-2 text-left text-xs md:text-sm font-semibold text-black"
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="whitespace-nowrap">
                {searchTableData.length > 0 ? (
                  searchTableData.slice(0, showEntries).map((item, index) => (
                    <tr key={index} className="even:bg-blue-50">
                      <td className="px-4 md:px-6 py-2">
                        <button className="mr-4" onClick={() => editEvent(item.id)}>
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-secondary hover:fill-custom-blue"
                            viewBox="0 0 348.882 348.882">
                            <path
                              d="m333.988 11.758-.42-.383A43.363 43.363 0 0 0 304.258 0a43.579 43.579 0 0 0-32.104 14.153L116.803 184.231a14.993 14.993 0 0 0-3.154 5.37l-18.267 54.762c-2.112 6.331-1.052 13.333 2.835 18.729 3.918 5.438 10.23 8.685 16.886 8.685h.001c2.879 0 5.693-.592 8.362-1.76l52.89-23.138a14.985 14.985 0 0 0 5.063-3.626L336.771 73.176c16.166-17.697 14.919-45.247-2.783-61.418zM130.381 234.247l10.719-32.134.904-.99 20.316 18.556-.904.99-31.035 13.578zm184.24-181.304L182.553 197.53l-20.316-18.556L294.305 34.386c2.583-2.828 6.118-4.386 9.954-4.386 3.365 0 6.588 1.252 9.082 3.53l.419.383c5.484 5.009 5.87 13.546.861 19.03z"
                              data-original="#000000" />
                            <path
                              d="M303.85 138.388c-8.284 0-15 6.716-15 15v127.347c0 21.034-17.113 38.147-38.147 38.147H68.904c-21.035 0-38.147-17.113-38.147-38.147V100.413c0-21.034 17.113-38.147 38.147-38.147h131.587c8.284 0 15-6.716 15-15s-6.716-15-15-15H68.904C31.327 32.266.757 62.837.757 100.413v180.321c0 37.576 30.571 68.147 68.147 68.147h181.798c37.576 0 68.147-30.571 68.147-68.147V153.388c.001-8.284-6.715-15-14.999-15z"
                              data-original="#000000" />
                          </svg>

                        </button>

                        <button className="mr-4" onClick={() => deleteEvent(item.id)}>
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-red-500 hover:fill-red-700" viewBox="0 0 24 24">
                            <path
                              d="M19 7a1 1 0 0 0-1 1v11.191A1.92 1.92 0 0 1 15.99 21H8.01A1.92 1.92 0 0 1 6 19.191V8a1 1 0 0 0-2 0v11.191A3.918 3.918 0 0 0 8.01 23h7.98A3.918 3.918 0 0 0 20 19.191V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM10 4V3h4v1Z"
                              data-original="#000000" />
                            <path d="M11 17v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Zm4 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Z"
                              data-original="#000000" />
                          </svg>
                        </button>
                      </td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">{item.eventName}</td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">{formatDateTimeForDisplay(item.startDate)}</td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">{formatDateTimeForDisplay(item.endDate)}</td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm break-words">
                        {item.eventCoordinatorNameEmailAddress}
                      </td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm break-all">
                        {item.eventCoordinatorEmail}
                      </td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">
                        {formatUSPhone(item?.eventCoordinatorPhone || "")}
                      </td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">{item.guest}</td>
                      <td className="px-4 md:px-6 py-2 text-xs md:text-sm">{item.isActive}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="px-2 py-1 text-sm text-center h-52">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalLength > 0 && (
            <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3">
              <Pagination
                pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                totalLength={totalLength}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                showEntries={showEntries}
                setShowEntries={setShowEntries}
              />
            </div>
          )}
        </>
      ) : (
        <div className="min-w-full h-[300px] md:h-[480px] flex justify-center items-center">
          <div className="flex flex-col items-center">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
            <span className="text-sm mt-2">Loading...</span>
          </div>
        </div>
      )}
    </section>
  )
}

export default Event